// @flow

import React from 'react';
import { connect } from 'react-redux';

import styles from './styles.scss';

import { DEFAULT_STATE } from '../../redux/reducers';

import type { CategoryType, BrandType } from '../../api/types';
import type { DefaultStateType } from '../../redux/reducers';

const getRandom = (min: number, max: number): number => Math.round(Math.random() * (max - min) + min);

const randomize = (arr: Array<any>): Array<any> => {
  const head = arr.slice(0, 11);
  const tail = arr.slice(11);

  const oldIndex = getRandom(0, head.length - 1);
  const newIndex = getRandom(0, tail.length - 1);

  const oldItem = head[oldIndex];
  const newItem = tail[newIndex];

  head[oldIndex] = newItem;
  tail[newIndex] = oldItem;

  return [...head, ...tail];
};

type Props = {
  categories: Array<CategoryType>,
  currentCategoryId: ?number,
  brands: Array<BrandType>,
};

type State = {
  displayBrands: Array<BrandType>,
};

class Footer extends React.Component<Props, State> {
  static defaultProps = {
    categories: DEFAULT_STATE.categories,
    currentCategoryId: DEFAULT_STATE.currentCategoryId,
    brands: DEFAULT_STATE.brands,
  };

  state = {
    displayBrands: [],
  };

  interval = null;

  componentDidMount = () => {
    const { brands, categories } = this.props;

    if (brands.length > 0 || categories.length > 0) {
      this.setBrands();
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      JSON.stringify(prevProps.brands) !== JSON.stringify(this.props.brands) ||
      JSON.stringify(prevProps.categories) !== JSON.stringify(this.props.categories)
    ) {
      this.setBrands();
    }

    if (prevProps.currentCategoryId !== this.props.currentCategoryId) {
      this.clearInterval();
      this.setBrands();

      const currentCategoryBrands = this.getCurrentCategoryBrands();

      if (this.props.currentCategoryId && currentCategoryBrands.length > 11) {
        this.setInterval();
      }
    }
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    if (
      nextProps.currentCategoryId !== this.props.currentCategoryId ||
      JSON.stringify(nextProps.brands) !== JSON.stringify(this.props.brands) ||
      JSON.stringify(nextState.displayBrands) !== JSON.stringify(this.state.displayBrands)
    ) {
      return true;
    }

    return false;
  };

  setInterval = () => {
    this.interval = setInterval(() => {
      this.setState(state => ({ displayBrands: randomize(state.displayBrands) }));
    }, 5000);
  };

  clearInterval = () => this.interval !== null && clearInterval(this.interval);

  setBrands = () => {
    let displayBrands;

    if (this.props.currentCategoryId) {
      displayBrands = this.getCurrentCategoryBrands();
    } else {
      displayBrands = this.props.brands.filter(brand => brand.url) || [];
    }

    this.setState({ displayBrands });
  };

  getCurrentCategoryBrands = () => {
    const currentCategory = this.props.categories.find(category => category.id === this.props.currentCategoryId);

    if (currentCategory && currentCategory.brands) {
      return currentCategory.brands;
    }

    return [];
  };

  render() {
    return this.state.displayBrands.length > 0 ? (
      <div className={styles.footer}>
        <div className={styles['maker-list']}>
          {this.state.displayBrands.map(
            (brand, index) =>
              index < 11 && (
                <a href={brand.url} key={brand.id} target="_blank" rel="noopener noreferrer">
                  <img src={brand.image} alt="brand" />
                </a>
              ),
          )}
        </div>
      </div>
    ) : null;
  }
}

const mapStateToProps = (
  state: DefaultStateType,
): { categories: Array<CategoryType>, currentCategoryId: ?number, brands: Array<BrandType> } => ({
  categories: state.categories,
  currentCategoryId: state.currentCategoryId,
  brands: state.brands,
});

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/index.js